import _objectSpread from "/home/jenkins/agent/workspace/chongyueyuedsn29/cyy-manage-web-new/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import BasicLayout from '@/layouts/basic-layout';
var meta = {};
var pre = 'setting-';
export default {
  path: '/setting',
  name: 'setting',
  redirect: {
    name: "".concat(pre, "user")
  },
  meta: meta,
  component: BasicLayout,
  children: [{
    path: '/setting/account',
    name: "".concat(pre, "account"),
    meta: _objectSpread(_objectSpread({}, meta), {}, {
      title: '个人设置',
      cache: true,
      icon: 'md-person'
    }),
    component: function component() {
      return import('@/sys-pages/setting/account');
    }
  }]
};